import {
  PLUGIN_UPDATE_INSTALLED_PLUGIN_BEGIN,
  PLUGIN_UPDATE_INSTALLED_PLUGIN_SUCCESS,
  PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE,
  PLUGIN_UPDATE_INSTALLED_PLUGIN_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function updateInstalledPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_UPDATE_INSTALLED_PLUGIN_BEGIN,
    });
    const { projectId, version, installedPluginId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/${installedPluginId}`,
        args.keystore,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: PLUGIN_UPDATE_INSTALLED_PLUGIN_SUCCESS,
              data: res.data.setting ? res.data.setting : null,
            });
            Mixpanel.track('Updated Plugin', { code: res.data.code });
            toast.success(`${res.data.name} Updated Successfully !`, {});
            resolve(res);
          } else {
            dispatch({
              type: PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to update plugin');
            let errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to update plugin');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateInstalledPluginError() {
  return {
    type: PLUGIN_UPDATE_INSTALLED_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_UPDATE_INSTALLED_PLUGIN_BEGIN:
      return {
        ...state,
        updateInstalledPluginPending: true,
        updateInstalledPluginError: null,
        // pluginDetail: null,
      };

    case PLUGIN_UPDATE_INSTALLED_PLUGIN_SUCCESS:
      return {
        ...state,
        updateInstalledPluginPending: false,
        updateInstalledPluginError: null,
        pluginDetail: action.data,
      };

    case PLUGIN_UPDATE_INSTALLED_PLUGIN_FAILURE:
      return {
        ...state,
        updateInstalledPluginPending: false,
        updateInstalledPluginError: action.data.error,
      };

    case PLUGIN_UPDATE_INSTALLED_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        updateInstalledPluginError: null,
      };

    default:
      return state;
  }
}
